/**
  * @ngdoc component
  * @name common.component:itxStoreLocatorHeader
  *  
  * @param {Function} closeDialog Output param 
  *
  * @description
  * Store locator header for mobile.
  * 
  * 
*/
(function () {

    'use strict';

    var ItxStoreLocatorHeaderCmp = {
        bindings: {
            closeDialog: '&'
        },
        controller: ItxStoreLocatorHeaderCmpCtrl,
        controllerAs: 'storeLocatorHeaderCtrl',
        templateUrl: 'store-locator-header.component.html'
    };

    ItxStoreLocatorHeaderCmpCtrl.$inject = ['ItxStoreLocatorSvc', 'ItxScreenSizeSvc','ItxTranslateSvc'];

    function ItxStoreLocatorHeaderCmpCtrl (ItxStoreLocatorSvc, ItxScreenSizeSvc,ItxTranslateSvc) {
        var _this = this;
        _this.ItxStoreLocatorSvc = ItxStoreLocatorSvc;

        _this.$onInit = function () {
            _this.text={
                title: ItxTranslateSvc.translateCms('legacy.title_stores')
            };
        };

        _this.changeStep = function () {
            if (ItxStoreLocatorSvc.getStep() === 'list') {
                ItxStoreLocatorSvc.setStep('map');
            } else {
                ItxStoreLocatorSvc.setStep('list');
            }
        };
    }

    angular.module('itxApp.common')
        .component('itxStoreLocatorHeader', ItxStoreLocatorHeaderCmp);

})(window.itxApp);
